import * as Sentry from "@sentry/react";
import {
  zeroDefinitionNotFoundDetails,
  zeroDefinitionNotFoundMessage,
} from "../../shared/zeroErrors";

export function reportZeroDefinitionNotFound(error: unknown) {
  const details = zeroDefinitionNotFoundDetails(error);
  if (!details) return;
  const exception = new Error(
    zeroDefinitionNotFoundMessage(details.definition, details.name),
    { cause: error }
  );
  Sentry.captureException(exception, {
    fingerprint: [
      "zero-definition-not-found",
      details.definition,
      details.name,
    ],
  });
}
